import { AUTH_SESSION_KEY, AUTH_USER_KEY } from '../models/constants';

function readStorage(key: string): string | null {
  try {
    return localStorage.getItem(key) ?? sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
    sessionStorage.setItem(key, value);
  } catch {
    /* noop */
  }
}

function removeStorage(key: string): void {
  try {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  } catch {
    /* noop */
  }
}

export function readAuthSessionId(): string | null {
  return readStorage(AUTH_SESSION_KEY);
}

export function persistAuthSession(sessionId: string, userName: string | null | undefined): void {
  writeStorage(AUTH_SESSION_KEY, sessionId);
  if (userName) writeStorage(AUTH_USER_KEY, userName);
  else removeStorage(AUTH_USER_KEY);
}

export function clearAuthSession(): void {
  removeStorage(AUTH_SESSION_KEY);
  removeStorage(AUTH_USER_KEY);
}

export function readAuthUserName(): string | null {
  return readStorage(AUTH_USER_KEY);
}
